import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const migraines: AnswerPathTreeNode = {
  path: 'migraines',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredMigrainesDetails }],
};
